import { isly } from "isly";
import { Numeric as DayOfWeekNumeric } from "./Numeric";
export var DayOfWeek;
(function (DayOfWeek) {
    var _a;
    DayOfWeek.Numeric = DayOfWeekNumeric;
    DayOfWeek.values = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
    _a = isly
        .string("value", ...DayOfWeek.values)
        .rename("isoly.DayOfWeek")
        .describe("Lower case weekday name in English.")
        .bind(), DayOfWeek.type = _a.type, DayOfWeek.is = _a.is, DayOfWeek.flawed = _a.flawed;
    function from(value) {
        return DayOfWeek.Numeric.is(value) ? DayOfWeek.values[value - 1] : from(DayOfWeek.Numeric.from(value));
    }
    DayOfWeek.from = from;
    function toNumeric(value) {
        return (DayOfWeek.values.indexOf(value) + 1);
    }
    DayOfWeek.toNumeric = toNumeric;
})(DayOfWeek || (DayOfWeek = {}));
//# sourceMappingURL=index.js.map